import styled from 'styled-components';
import { colors, fonts, media, mixins } from '../css';

export const AgreementAuthWrapper = styled.div`
  padding: ${mixins.pxToRem(24)} ${mixins.pxToRem(12)} ${mixins.pxToRem(24)} ${mixins.pxToRem(24)};
  text-align: left;
  background: ${colors.colorGrey05};
  border: solid 1px ${props => (props.error ? colors.colorRed : colors.colorBlue)};

  ${media.greaterThan('md')`
    padding: ${mixins.pxToRem(33)} ${mixins.pxToRem(17)} ${mixins.pxToRem(33)} ${mixins.pxToRem(33)};
    text-align: center;
  `};
`;

// An attempt to replicate the MaterialUI error messages
export const AgreementAuthErrorMessage = styled.div`
  margin-top: 8px;
  line-height: 1.2em;
  text-align: left;
  font-family: ${fonts.fontRegular};
  font-size: 12px;
  color: ${colors.colorRed};
`;
